/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-05-27.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-05-27.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-05-27.mdx';

const metadata = {
  slug: "2019-05-27",
  title: "Memorial Day Weekend in NYC",
  author: "Christian Battaglia",
  description: "A marathon Memorial Day weekend in New York — from happy hour logistics at Rosie's to Rockaway Beach, the social dynamics of group planning, and the art of contextualizing friendships.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/meanderings/rockaway.jpg",
  date: "2019-05-27T00:00:00.000Z",
  
  readTime: "21 min read",
  tags: ["NYC","Memorial Day","friends","Rockaway","Hamptons","summer","social dynamics","East Village"],
};

export const Route = createFileRoute('/blog/posts/2019-05-27')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-05-27',
    image: '/og/blog/2019-05-27.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
